import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentItrackStatusAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentLookUpForItrack`,
    method: 'get',
  });
};

export type ShipmentItrackStatusResponse = {
  codeId: string;
  codeDesc: string;
  lookUpCodeType: null;
  lookupKey: number;
}[];

export const fetchShipmentItrackStatus = async (): Promise<ShipmentItrackStatusResponse> => {
  const response: AxiosResponse<ShipmentItrackStatusResponse> = await getShipmentItrackStatusAPI();
  return response.data;
};
